import React, { Fragment } from 'react'
import styled from 'styled-components'
import { media, style } from 'app/assets/styles'
import { FormattedMessage } from 'react-intl'
import { ModalTitle } from 'app/common/modals/title'
import { H2, H4, H5, H6 } from 'app/common/typography'
import { colors } from 'shared/assets/styles'
import { toSrcSet } from 'shared/utils'
import { Picture } from 'react-responsive-picture'
import Modal from 'react-modal'
import tutorial_privileges_1x from 'shared/assets/images/kingdom-points/new_tutorial_privilege_coupons_1x.webp'
import tutorial_privileges_2x from 'shared/assets/images/kingdom-points/new_tutorial_privilege_coupons_2x.webp'
import tutorial_privileges_3x from 'shared/assets/images/kingdom-points/new_tutorial_privilege_coupons_3x.webp'

const images = [
    tutorial_privileges_1x,
    tutorial_privileges_2x,
    tutorial_privileges_3x
]
const { yellow, bbqBrown } = colors

type Props = {
    isOpen: boolean,
    mobile: boolean,
    handleClose: () => void
}

const TutorialModal = (props: Props) => {
    const { isOpen, mobile, handleClose } = props
    return (
        <Modal
            ariaHideApp={false}
            isOpen={isOpen}
            shouldCloseOnOverlayClick
            onRequestClose={handleClose}
            style={
                mobile ? style.classicModalMobileStyle : style.classicModalStyle
            }>
            <Container>
                <ModalTitle
                    center
                    handleClose={handleClose}
                    color={bbqBrown}
                    titleNode={
                        <Fragment>
                            <>
                                <FormattedMessage id="kingdom.dashboard.title">
                                    {(text: string) => <H2 center>{text}</H2>}
                                </FormattedMessage>
                                <FormattedMessage id="help.privileges">
                                    {(text: string) => (
                                        <H4 center color={yellow}>
                                            {text}
                                        </H4>
                                    )}
                                </FormattedMessage>
                            </>
                        </Fragment>
                    }
                />
                <StyledPicture
                    sources={[
                        {
                            srcSet: toSrcSet(images)
                        }
                    ]}
                />
            </Container>
            <DriveHelper>
                <FormattedMessage id="kingdom.privileges.tuto.drive.help">
                    {(label: string) => (
                        <H5 center color="white">
                            {label}
                        </H5>
                    )}
                </FormattedMessage>
                <FormattedMessage id="kingdom.privileges.tuto.drive.description">
                    {(label: string) => <H6 center>{label}</H6>}
                </FormattedMessage>
            </DriveHelper>
        </Modal>
    )
}

const Container = styled.div`
    padding: 15px;
    ${media.medium`
        padding: 40px;
    `};
`

const StyledPicture = styled(Picture)`
    width: 100%;
    height: 100%;
    margin: 40px 0;
`

const DriveHelper = styled.div`
    padding: 25px;
    background: ${yellow};
    margin-top: -20px;
`

export { TutorialModal }
